// extracted by mini-css-extract-plugin
export default {"HeaderWrapper":"Header_HeaderWrapper__xV6zr","Header":"Header_Header__Z9Z4k","Link":"Header_Link__cMFeT","NavLink":"Header_NavLink__qai0U"};